import { InviteClientModel } from '@pages/oneLid/utils/models/InviteClientModel';

import { crmModels } from 'modules/crm';

import { BaseLanguageEntity } from './BaseLanguageEntity';
import { CurrencyItem } from './Currency';
import { EmployeeStatus } from './EmployeeStatus';
import { PipeStatuses } from './PipeAll';

export interface FieldValue {
  id: number;
  value?: string;
  valueType?: string;
  valueList?: string[];
}

export enum TypeContact {
  INSTAGRAM = 'INSTAGRAM',
  TELEGRAM = 'TELEGRAM',
  FACEBOOK = 'FACEBOOK'
}

export interface ContactCrm {
  id: number | null;
  name: string;
  avatar?: string;
  fields: FieldValue[];
  username?: string;
  avatarId?: number;
  type?: TypeContact;
  accountId?: string;
  phones: string[];
}

export interface OneLid {
  id: number;
  name: string;
  balance: number;
  responsibleById?: number;
  responsibleBy?: string;
  createdDate?: string;
  createdTimestamp: number | null;
  pipeStatusResponse: PipeStatuses;
  tags: crmModels.ITags['tagList'];
  fields: FieldValue[];
  contacts: ContactCrm[];
  isMoiZvonki: boolean;
  deletedBy?: string;
  deletedDate?: string;
  deletedTimestamp?: number | null;
  client: InviteClientModel;
  uuid?: string;
  currencyDto?: CurrencyItem;
  deleteExpiryDay?: number;
}

export interface CrmEmployee {
  id: number;
  fullName: string;
  role?: BaseLanguageEntity;
  phone?: string;
  expiry?: null | string;
  status?: EmployeeStatus;
  avatar: null;
  company?: string;
  haveAccess?: boolean;
  department: {
    id: number;
    name: string;
  } | null;
}

export interface ICrmGroupEmployee {
  id: number;
  name: string;
  employees: CrmEmployee[];
}
